import { useState } from 'react';
import CountdownTimer from '../../../components/Common/CountDownTimer';
import { resendVerificationEmail } from '../services/builderHelpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

interface AccountVerficationProps {
  setLoaders: any;
  loaders: any;
}

const AccountVerfication = ({ setLoaders, loaders }: AccountVerficationProps) => {
  const user = useSelector((state: RootState) => state.user.user);

  const [visibleTarget, setVisibleTarget] = useState({
    resendVerificationEmail: true
  });

  return (
    <>
      <div className="text-storygreen  text-bold my-3   text-xl">
        <b>Thank You For Your Subscription </b>
        <br></br> <br></br>
        <br></br>
      </div>
      <h2 className="text-left text-2xl md:text-4xl mb-4 font-bold text-storyblue">Account Verification</h2>
      <div className="text-storygreen text-bold mt-2 text-xl">
        We’ve sent you an email from Build My Story. In order to start creating your story, you must first
        verify your account by clicking on the link provided in the email, which will take you to the next
        step! <br></br>
        <br></br>
        <span className="text-base italic text-red-800">
                    *Please note! If you don’t find the verification email, it will be sent from “Build My Story” please
                    check your spam folder
          {visibleTarget?.resendVerificationEmail ? (
            <span
              onClick={() => {
                resendVerificationEmail(loaders, setLoaders, user?.email!, user?.firstName!);
                setVisibleTarget({ ...visibleTarget, resendVerificationEmail: false });
              }}
            >
                            {' '}
              or click{' '}
              <span className="italic underline font-bold cursor-pointer hover:text-storygreen">
                                {' '}
                request a new verification email.
                            </span>
                        </span>
          ) : (
            <CountdownTimer
              durationInSeconds={20}
              text="You can resend email after 20 seconds"
              processAfterTimerStopped={() => {
                setVisibleTarget({ ...visibleTarget, resendVerificationEmail: true });
              }}
            />
          )}
                </span>
      </div>
    </>
  );
};

export default AccountVerfication;